import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const navLinks = [
  { name: 'How it works', href: 'how-it-works' },
  { name: 'What Claw does', href: 'capabilities' },
  { name: 'What could Claw do for you?', href: 'quiz' },
  { name: 'Pricing', href: 'pricing' },
  { name: 'FAQ', href: 'faq' },
];

const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
};

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
      const sections = navLinks.map((l) => document.getElementById(l.href));
      let current = '';
      sections.forEach((sec) => {
        if (sec && window.scrollY >= sec.offsetTop - 120) current = sec.id;
      });
      setActiveSection(current);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'bg-[#F8F6F3]/92 backdrop-blur-xl border-b border-[#E8E2DA] shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="flex items-center gap-2.5 group">
            <div className="w-7 h-7 rounded-xl bg-[#1A1A18] flex items-center justify-center text-sm">🦞</div>
            <div className="text-left">
              <span className="text-[15px] font-bold text-[#1A1A18] tracking-tight leading-none block">HelloClaw</span>
              <span className="text-[9px] font-mono-custom text-[#9E9690] tracking-[0.18em] uppercase">personal assistant</span>
            </div>
          </button>

          <div className="hidden md:flex items-center gap-6">
            {navLinks.map((item) => (
              <button
                key={item.name}
                onClick={() => scrollToSection(item.href)}
                className="relative text-[12px] font-medium transition-colors group"
              >
                <span className={activeSection === item.href ? 'text-[#2D6A8F]' : 'text-[#6B6560] hover:text-[#1A1A18]'}>
                  {item.name}
                </span>
                <motion.span
                  className="absolute -bottom-0.5 left-0 h-px bg-[#2D6A8F]"
                  initial={false}
                  animate={{ width: activeSection === item.href ? '100%' : '0%' }}
                  transition={{ duration: 0.25 }}
                />
              </button>
            ))}
          </div>

          <button className="btn-primary text-[13px] flex items-center gap-2">
            Get started <SafeIcon icon={FiIcons.FiArrowRight} className="text-xs" />
          </button>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;